export default __webpack_public_path__ + "static/media/theme_gyser.c81b1019.jpg";